import { useTrackReferralClick } from '@services/referral'
import { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'

export function ReferralRedirect() {
  const [searchParams] = useSearchParams()
  const referralCode = searchParams.get('ref')
  const trackClick = useTrackReferralClick()

  useEffect(() => {
    // Track the referral click when someone visits the link
    if (referralCode) {
      trackClick.mutate({ body: { referral_code: referralCode } })
    }
  }, [referralCode, trackClick])

  // If no referral code, redirect to normal registration
  if (!referralCode) {
    return <Navigate to="/register" replace />
  }

  // Redirect to registration with referral code pre-filled
  return <Navigate to={`/register?ref=${referralCode}`} replace />
}
